<template>
<div class="mt-5">
    <div class="intro-y rounded-md flex items-center px-5 py-4 mb-2 bg-theme-31 text-theme-6 mt-5" v-if="errors.length > 0" v-for="(error, key) in errors" :key="key"> 
        <fa-icon :icon="['fas', 'exclamation-triangle']" class="w-6 h-6 mr-2" /> {{ error }} 
    </div>
</div>
</template>
<script>
export default {
    name: 'DisplayErrors',
    props: {
      errors: Array,
    }
}
</script>

<style scoped>

</style>